import { getAllCountries } from "countries-and-timezones";

export const sortedCountries = () => {
  const countries = getAllCountries();
  return Object.values(countries).sort((a, b) => a.name.localeCompare(b.name));
};
